<template>
  <tr
    class="tableRow"
    valign="middle"
  >
    <td align="center" style="width:15%;">
      {{ id }}
    </td>
    <td style="width:14%;">
      {{ endAt }}
    </td>
    <td align="center" style="width:26%;">
      <div class="bullCard-container">
        <div>
          <div class="bullCard-groupTitle">
            <div title="Người&nbsp;chơi">Player</div>
          </div>
          <div>
            <span v-if="data.playerCard3Number !== ''" class="bullCard fr-main-txt">
              <div :class="classNumberColor(data.playerCard3Suit)">
                {{ data.playerCard3Number }}
              </div>
              <div class="bullCard-image-top">
                <component :is="classSuit(data.playerCard3Suit)" />
              </div>
            </span>
            <span class="bullCard fr-main-txt">
              <div :class="classNumberColor(data.playerCard2Suit)">
                {{ data.playerCard2Number }}
              </div>
              <div class="bullCard-image-top">
                <component :is="classSuit(data.playerCard2Suit)" />
              </div>
            </span>
            <span class="bullCard fr-main-txt">
              <div :class="classNumberColor(data.playerCard1Suit)">
                {{ data.playerCard1Number }}
              </div>
              <div class="bullCard-image-top">
                <component :is="classSuit(data.playerCard1Suit)" />
              </div>
            </span>
          </div>
        </div>
        <div>
          <div class="bullCard-groupTitle">
            <div title="Nhà&nbsp;cái">Banker</div>
          </div>
          <div>
            <span class="bullCard fr-main-txt">
              <div :class="classNumberColor(data.bankerCard1Suit)">
                {{ data.bankerCard1Number }}
              </div>
              <div class="bullCard-image-top">
                <component :is="classSuit(data.bankerCard1Suit)" />
              </div>
            </span>
            <span class="bullCard fr-main-txt">
              <div :class="classNumberColor(data.bankerCard2Suit)">
                {{ data.bankerCard2Number }}
              </div>
              <div class="bullCard-image-top">
                <component :is="classSuit(data.bankerCard2Suit)" />
              </div>
            </span>
            <span v-if="data.bankerCard3Number !== ''" class="bullCard fr-main-txt">
              <div :class="classNumberColor(data.bankerCard3Suit)">
                {{ data.bankerCard3Number }}
              </div>
              <div class="bullCard-image-top">
                <component :is="classSuit(data.bankerCard3Suit)" />
              </div>
            </span>
          </div>
        </div>
    </div>
    </td>
    <td align="center" style="width:10%;">
      {{ winner() }}
    </td>
    <!-- <td align="center" style="width:10%;">
      <span :class="getBigSmallColor()">{{getBigSmall()}}</span>
    </td>
    <td align="center" style="width:10%;">
      <span :class="getTotalBigSmallColor()">{{getTotalBigSmall()}}</span>
      <span :class="getTotalOddEvenColor()">{{getTotalOddEven()}}</span>
    </td> -->
  </tr>
</template>

<script>
import CrossWhiteIcon from '@assets/icons/cross-white.svg';
import SpadeSign from '@assets/icons/spade-sign.svg';
import HeartSign from '@assets/icons/heart-sign.svg';
import ClubSign from '@assets/icons/club-sign.svg';
import DiamondSign from '@assets/icons/diamond-sign.svg';

export default {
  components: {
    CrossWhiteIcon,
    SpadeSign,
    HeartSign,
    ClubSign,
    DiamondSign,
  },
  props: {
    id: Number,
    endAt: String,
    data: Object,
  },
  methods: {
    winner: function(){
      if(this.data.result === undefined) return "";
      return this.data.result === "TIE" ? "H" : this.data.result[0];
    },
    getBigSmallColor: function() {
      const value = this.data.bigSmall;
      return value === "NORMAL_BIG" ? "color-red" : "color-blue";
    },
    getBigSmall: function() {
      const value = this.data.bigSmall;
      if(value === '' || value === undefined) return '';
      return value === "NORMAL_SMALL" ? "X" : "T";
    },
    getTotalBigSmallColor: function() {
      const value = this.data.totalBigSmall;
      return value === "TOTAL_BIG" ? "color-red" : "color-blue";
    },
    getTotalBigSmall: function() {
      const value = this.data.totalBigSmall;
      if(value === '' || value === undefined) return '';
      return value === "TOTAL_SMALL" ? "X" : "T";
    },
    getTotalOddEvenColor: function() {
      const value = this.data.totalOddEven;
      return value === "TOTAL_EVEN" ? "color-red" : "color-blue";
    },
    getTotalOddEven: function() {
      const value = this.data.totalOddEven;
      if(value === '' || value === undefined) return '';
      return value === "TOTAL_ODD" ? "L" : "C";
    },
    classSuit: function(value) {
      switch(value){
        case 1: return SpadeSign;
        case 2: return ClubSign;
        case 3: return DiamondSign;
        case 4: return HeartSign;
      }
    },
    classNumberColor: function(suit) {
      return suit > 2 ? "flipResult-barh-card-number-red" : "flipResult-barh-card-number-black";
    },
  }
}
</script>

